const BASE_URL = "https://webservice-nuebiv6e5a-ew.a.run.app"

export default BASE_URL
